import { render, staticRenderFns } from "./PurchaseInvoiceDetail.vue?vue&type=template&id=1b003f1e&scoped=true&lang=pug&"
import script from "./PurchaseInvoiceDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./PurchaseInvoiceDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PurchaseInvoiceDetail.vue?vue&type=style&index=0&id=1b003f1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b003f1e",
  null
  
)

export default component.exports